<template>
  <div>
    <ProcessHotspotModal v-if="processHotspot" />
    <SolutionsHotspotModal v-if="solutionsHotspot"  />
  </div>
</template>
<script src="./HotspotModal"></script>
